const backInStockBtns = document.querySelectorAll('.item-select__notification.backInStock');
const showVariants = document.querySelector('#show-variants');
backInStockBtns.forEach((item) => {
  item.addEventListener('click', () => {
    // BackInStockのiframeを取得
    const variantsSelect = document
      .querySelector('#BIS_frame')
      .contentDocument.getElementById('variants');
    const variantId = item.getAttribute('data-variant-id');
    if (showVariants.value) {
      const showVariantsIds = showVariants.value.split(',');
      // showVariantsIdsの中に含まれていないoptionは非表示にする
      // showVariantsIdsの中に含まれていないoptionを削除する
      variantsSelect.querySelectorAll('option').forEach((option) => {
        if (!showVariantsIds.includes(option.value)) {
          option.remove();
        }
      });
    }
    handleBackInStock(variantId);
  });
});

// カートに追加し、カート画面へ遷移
const cartAdd = async (variantId) => {
  console.log;
  const formData = {
    items: [
      {
        quantity: 1,
        id: variantId,
      },
    ],
  };

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      dataType: 'json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((res) => {
      if (res.ok) {
        window.location.href = '/cart';
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};

// カート追加を押した時の処理
const addButtons = document.querySelectorAll('.item-select__add');
addButtons.forEach((item) => {
  item.addEventListener('click', () => {
    const variantId = item.getAttribute('data-id');
    cartAdd(variantId);
  });
});

window.addEventListener('DOMContentLoaded', function () {
  // カート追加を押した時の処理
  const addButtons = document.querySelectorAll('.js-add-button.sp');
  addButtons.forEach((item) => {
    item.addEventListener('click', () => {
      const variantId = item.getAttribute('data-id');
      cartAdd(variantId);
    });
  });

  // モーダル表示・非表示
  const cartModal = document.querySelector('.item-select-modal');
  const modalTriggers = document.querySelectorAll(
    '.item-select-modal__overlay, .item-select-modal__close, .item-select-modal__bottom-close, .product-form__buttons, .js-modal-open'
  );

  const animationDuration = 500;

  modalTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      if (cartModal.classList.contains('is-show')) {
        // モーダルを非表示にする場合
        cartModal.animate([{ opacity: '1' }, { opacity: '0' }], {
          duration: animationDuration,
          easing: 'ease-in-out',
          fill: 'forwards',
        }).onfinish = () => {
          cartModal.style.display = 'none';
          cartModal.classList.toggle('is-show');
        };
      } else {
        // モーダルを表示する場合
        cartModal.style.opacity = 0;
        cartModal.style.display = 'block';
        cartModal.classList.toggle('is-show');
        cartModal.animate([{ opacity: '0' }, { opacity: '1' }], {
          duration: animationDuration,
          easing: 'ease-in-out',
          fill: 'forwards',
        });
      }
    });
  });

  /* SP版カートをワンスクロール後に表示*/
  let setPosition = 0;
  // product__addToCart__bottomが見え始める位置を取得
  const hiddenBorderElement = document.querySelector('.product__addToCart__bottom');
  const hiddenBorderPosition =
    hiddenBorderElement.getBoundingClientRect().top +
    window.scrollY -
    window.innerHeight -
    hiddenBorderElement.clientHeight -
    100;
  var scroll = document.querySelectorAll('.item-select-sp');

  var Animation = function () {
    for (var i = 0; i < scroll.length; i++) {
      var triggerMargin = 80;
      if (window.innerHeight > scroll[i].getBoundingClientRect().top + triggerMargin) {
        scroll[i].classList.add('show');
      }
      // 上にスクロールしたら非表示にする
      if (document.documentElement.scrollTop < setPosition) {
        scroll[i].classList.remove('show');
      }
      // hiddenBorderPosition　よりも下にスクロールしたら非表示にする
      if (document.documentElement.scrollTop > hiddenBorderPosition) {
        scroll[i].classList.remove('show');
      }
      // hiddenBorderPosition　よりも上にスクロールしたら表示する
      if (document.documentElement.scrollTop > 600 && setPosition < hiddenBorderPosition) {
        console.log('heyhey');
        scroll[i].classList.add('show');
      }
      console.log('setPosition', setPosition);
      console.log('hiddenPosition', hiddenBorderPosition);
      setPosition = document.documentElement.scrollTop;
    }
  };
  window.addEventListener('scroll', Animation);
});

/**
 * 再入荷通知のポップアップ表示
 * @param {string} variantId
 */
const handleBackInStock = (variantId) => {
  if (BIS) {
    BIS.popup.show({ variantId });
  }
};
